import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question:
      " Which mobile app development services does TekRevol provide in Texas?",
    answer: ` <p>We provide end-to-end mobile app development services in Texas, including app consultancy, UI and UX design, development, prototyping, app testing, deployment, launch, and maintenance.</p>`,
  },
  {
    question: "Does TekRevol provide app consultancy?",
    answer: ` <p>Yes, TekRevol provides app consultancy services, and that typically include competitor analysis, app scope, and discovery, features, targeting, and monetization research.</p>`,
  },
  {
    question: "How much does it cost to develop a mobile app in Texas?",
    answer: `<p>It costs around $10,000-$15,000 for the discovery phase, $10,000-$15,000 in the designing phase, and $5,000 for the development of advanced features like notifications and analytics.</p>
        <p>Other than that, the testing, maintenance, and support phase costs around $5,000-$10,000.</p>
        <p>However, the cost of mobile app development varies depending on the scope, timeline, technology stack, and the platforms businesses choose for app development.</p>`,
  },
  {
    question: "How does your team handle the changes in scope and timeline?",
    answer: ` <p>We critically evaluate the need for such changes. Then we study and inform about the changes in scope and timeline of the processes, sprints, development hours, and budget.</p>
        <p>After approval from the client’s side as well as our project managers and business analysts, we implement the changes with strong communication of the same throughout the team.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
